import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {TerminaisModel} from "./terminais.model";
import {TerminaisService} from './terminais.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-terminais-form',
  templateUrl: './terminais-form.component.html'
})
export class TerminaisFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  terminal: TerminaisModel = new TerminaisModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private terminaisService: TerminaisService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_terminal'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.visualizarTerminal');
      }else{
        this.title = id ? this.func.traduzir('front.editarTerminal') : this.func.traduzir('front.cadastrarNovoTerminal');
      }

      if (!id) {
        return;
      }

      this.terminaisService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarTerminal')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarTerminal') + ': ' + json.Payload[0].nome;
            }

            this.terminal = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.terminaisService.editar(values, values.id);
    } else {
      result = this.terminaisService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'terminais']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if(json.Message && json.Message.ErrorInput){
          for(let i in json.Message.ErrorInput){
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/terminais/terminais-form.component.ts